<script setup>

const props = defineProps({
  backgroundSection: {
    type: String,
    default: "#AB4F35"
  },
  products: {
    type: Array,
    default: () => [
      {
        id: '43362772680764',
        qty: 1,
        price: 25.95,
        title: '1 Unit',
        imageUrl: '/assets/images/mushroom-1-product.png',
        discount:'?discount=YFJACAMN7D2D'
      },
      {
        id: '41356596707388',
        qty: 1,
        price: 69.95,
        title: '3 Unit',
        imageUrl: '/assets/images/mushroom-3-product.png',
        discount:'?discount=RHWPYWS47TEA'
      },
      {
        id: '41356596740156',
        qty: 1,
        price: 127.95,
        title: '6 Unit',
        imageUrl: '/assets/images/COGNITION_OFFER_-_6_BAGS.png',
        discount:'?discount=PE7MVZN0QS79'
      }
    ]
  },
  sectionTitle: {
    type: String,
    default: "Make the Switch Today"
  },
  sectionDescription: {
    type: String,
    default: "Are you eager to redefine your coffee experience with a blend that's organic, delicious, and truly beneficial? Order Now and discover the ultimate coffee experience that aligns with your wellness goals and taste preferences."
  },
  buttonText: {
    type: Array,
    default: () => ["Add to Cart", "Add to Cart", "Add to Cart"]
  },
  primaryColor: {
    type: String,
    default: "#e28831" // Това е примерна стойност за lifeboost-orange-middle
  }
});

const cart = useCart();

function addToCart(product) {
  cart.add({...product, title: "Cognition Mushroom Ground coffee"});
  cart.checkout("", true);
}

defineBuilderComponent({
  friendlyName: 'BasicSwatches',
  inputs: [
    { name: 'backgroundSection', type: 'color', defaultValue: '#AB4F35' },
    {
      name: "products",
      type: "list",
      subFields: [
        {
          name: "id",
          type: "text",
          defaultValue: ""
        },
        {
          name: "qty",
          type: "number",
          defaultValue: 1
        },
        {
          name: "price",
          type: "number",
          defaultValue: 0.00
        },
        {
          name: "title",
          type: "text",
          defaultValue: ""
        },
        {
          name: "imageUrl",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
          defaultValue: "/assets/images/mushroom-1.png"
        },
        {
          name: "discount",
          type: "text",
          defaultValue: ""
        },
      ],
      defaultValue: [
        {
          id: '43362772680764',
          qty: 1,
          price: 25.95,
          title: '1 Unit',
          imageUrl: '/assets/images/mushroom-1-product.png',
          discount:'?discount=YFJACAMN7D2D'
        },
        {
          id: '41356596707388',
          qty: 1,
          price: 69.95,
          title: '3 Unit',
          imageUrl: '/assets/images/mushroom-3-product.png',
          discount:'?discount=RHWPYWS47TEA'
        },
        {
          id: '41356596740156',
          qty: 1,
          price: 127.95,
          title: '6 Unit',
          imageUrl: '/assets/images/COGNITION_OFFER_-_6_BAGS.png',
          discount:'?discount=PE7MVZN0QS79'
        }
      ]
    },
    {
      name: "sectionTitle",
      type: "richText",
      defaultValue: "Make the Switch Today"
    },
    {
      name: "sectionDescription",
      type: "richText",
      defaultValue: "Are you eager to redefine your coffee experience with a blend that's organic, delicious, and truly beneficial? Order Now and discover the ultimate coffee experience that aligns with your wellness goals and taste preferences."
    },
    {
      name: "primaryColor",
      type: "color",
      defaultValue: "#e28831"
    }
  ]
});
</script>

<template>
  <section :style="{ background: backgroundSection }" data-testid="basic-swatches-section">
    <div class="block overflow-hidden relative aspect-auto" id="the-products">
      <!-- <nuxt-img
          width="1046"
          height="611"
          format="webp"
          sizes="sm:697px md:100vw lg:100vw xl:1046px"
          src="/assets/images/bg-latte-hero.png"
          alt="Nature Behind Rainbow Coffee"
          class="object-cover absolute w-full h-full brightness-75 h-6/6 sm-max:min-h-full"
          loading="lazy"
      /> -->
      <div class="py-8 sm:py-16 md-max:!pt-0">
        <div class="relative z-20 mx-auto max-w-screen-lg">
          <div class="relative py-8 mx-auto text-center backdrop-brightness-75 md-max:mt-0">
            <div class="font-extrabold text-white z-[1] relative h2 pb-4 md-max:px-4" v-html="sectionTitle" data-testid="basic-swatches-title"></div>
            <div class="max-w-4xl mx-auto pt-0 z-[1] relative text-white textp md-max:px-4" v-html="sectionDescription" data-testid="basic-swatches-description">
            </div>
            <div class="absolute top-0 w-full h-full opacity-50 bg-glassmorhpism"></div>
          </div>
        </div>
        <div class="mt-16 lg:mt-20" :style="{ background: backgroundSection }">
          <div class="relative z-0">
            <div class="absolute inset-0 h-5/6 lg:h-2/3"></div>
            <div class="px-4 mx-auto max-w-7xl 2xl:px-0 sm:px-6 lg:px-8">
              <div class="relative gap-x-4 lg:grid lg:grid-cols-3">
                <div data-testid="product-card-1"
                  class="mx-auto mt-10 max-w-lg duration-200 lg:mt-0 lg:max-w-none lg:mx-0 hover:scale-105">
                  <div class="relative z-10 py-4 bg-white rounded-lg shadow-xl">
                    <div class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                      :style="{ borderColor: primaryColor }" aria-hidden="true"></div>

                    <div class="rounded-t-lg">
                      <div>
                        <h3 class="text-4xl font-semibold text-center text-gray-900 font-ww-medium sm:-mx-6" data-testid="product-card-1-title"
                          id="tier-growth">
                          {{ products[0].title }}
                        </h3>

                        <div class="text-4xl font-semibold text-center font-ww-medium" data-testid="product-card-1-price-per-unit">
                          ${{ (products[0].price).toFixed(2) }} Per unit
                        </div>

                        <div class="mt-3 w-full lg:h-10">
                        
                        </div>
                        <div class="px-2 py-1">
                          <nuxt-img class="object-contain px-2 mx-auto w-auto h-64 xl:h-80 lg:px-0" :src="products[0].imageUrl"
                            loading="lazy" format="webp" width="320" height="320"
                            sizes="sm:320px md:320px lg:320px xl:320px" :alt="products[2].title" />
                        </div>
                        <div class="flex flex-col justify-center items-center lg:mt-2">
                          <span data-testid="product-card-1-price"
                            class="flex items-start px-3 text-6xl tracking-tight text-gray-900 sm:text-6xl font-ww-medium">
                            <span class="mt-2 mr-2 text-5xl font-medium">$</span>
                            <span class="font-extrabold">{{ products[0].price }}</span>
                          </span>
                          <div class="flex gap-x-1 items-center mt-2">
                            <div>
                          
                             
                            </div>
                            <div class="text-lg font-semibold font-ww-medium text-lifeboost-ambassador" data-testid="product-card-1-shipping-note">
                              Plus S&H
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-6 py-4 -mt-1 rounded-b-lg">

                        <div class="">
                          <button @click="addToCart(products[0])" data-testid="product-card-1-button"
                            class="flex gap-x-2 justify-center items-center px-6 py-2 w-full leading-6 text-center text-white uppercase rounded-full border-2 shadow-md us-max:text-2xl text-27 sm:text-3xl lg:py-4 lg:text-2xl xl:text-4xl hover:shadow-lg hover:opacity-80 font-ww-medium hover:bg-opacity-80"
                            :style="{ backgroundColor: primaryColor, borderColor: primaryColor }"
                            aria-describedby="tier-growth">
                            {{ buttonText[0] }}
                            

                            <span class="p-2 bg-white rounded-full lg:p-2">
                              <svg class="w-6 h-6 text-lifeboost-orange-middle xl:w-8 xl:h-8" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2s2-.9 2-2s-.9-2-2-2m-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59L3.62 17H19v-2H7z"/></svg>
                            </span>

                          </button>

                        <div class="px-4 mt-4 lg:px-8">
                          <nuxt-img class="" src="/assets/images/custom-payments.svg"
                            loading="lazy" format="webp" width="999" height="80" alt="custom payments"
                            sizes="sm:320px md:320px lg:320px xl:320px" />
                        </div>

                        </div>
                    
                    </div>
                  </div>
                </div>

                <div data-testid="product-card-2"
                  class="mx-auto mt-10 max-w-lg duration-200 lg:-mt-6 lg:max-w-none lg:mx-0 hover:scale-105">
                  <div class="relative z-10 bg-[#ffe4c4] rounded-lg shadow-xl py-4">
                    <div class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                      :style="{ borderColor: primaryColor }" aria-hidden="true"></div>

                    <div class="rounded-t-lg">
                      <div>
                        <h3 class="text-4xl font-semibold text-center text-gray-900 font-ww-medium sm:-mx-6" data-testid="product-card-2-title"
                          id="tier-growth">
                          {{ products[2].title }}
                        </h3>

                        <div class="text-4xl font-semibold text-center font-ww-medium" data-testid="product-card-2-price-per-unit">
                          ${{ (products[2].price / 6).toFixed(2) }} Per unit
                        </div>

                        <div class="mt-3 w-full">
                          <div
                            class="py-1 text-xl font-semibold tracking-wider text-center text-white uppercase font-ww-medium"
                            :style="{ backgroundColor: primaryColor }" data-testid="product-card-2-badge">
                            Most popular
                          </div>
                        </div>
                        <div class="px-2 py-1 lg:py-5">
                          <nuxt-img class="object-contain px-2 mx-auto w-auto h-64 xl:h-80 lg:px-0" :src="products[2].imageUrl"
                            loading="lazy" format="webp" width="320" height="320"
                            sizes="sm:320px md:320px lg:320px xl:320px" :alt="products[2].title" />
                        </div>
                        <div class="flex flex-col justify-center items-center lg:mt-2">
                          <span data-testid="product-card-2-price"
                            class="flex items-start px-3 text-6xl tracking-tight text-gray-900 sm:text-6xl font-ww-medium">
                            <span class="mt-2 mr-2 text-5xl font-medium">$</span>
                            <span class="font-extrabold">{{ products[2].price }}</span>
                          </span>
                          <div class="flex gap-x-1 items-center mt-2">
                            <div>
                              <nuxt-img class="" alt="shipping" src="/assets/images/shipping-cart.svg"
                            loading="lazy" format="webp" width="30" height="30"
                            sizes="sm:320px md:320px lg:320px xl:320px" />
                             
                            </div>
                            <div class="text-lg font-semibold font-ww-medium text-lifeboost-ambassador" data-testid="product-card-2-shipping-note">
                              Plus Free Shipping
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-6 py-4 -mt-1 rounded-b-lg lg:mb-5">

                        <div class="">
                          <button @click="addToCart(products[2])" data-testid="product-card-2-button"
                            class="flex gap-x-2 justify-center items-center px-6 py-2 w-full leading-6 text-center text-white uppercase rounded-full border-2 shadow-md us-max:text-2xl text-27 sm:text-3xl lg:py-4 lg:text-2xl xl:text-4xl hover:shadow-lg hover:opacity-80 font-ww-medium hover:bg-opacity-80"
                            :style="{ backgroundColor: primaryColor, borderColor: primaryColor }"
                            aria-describedby="tier-growth">
                            {{ buttonText[2] }}
                            

                            <span class="p-2 bg-white rounded-full lg:p-2">
                              <svg class="w-6 h-6 text-lifeboost-orange-middle xl:w-8 xl:h-8" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2s2-.9 2-2s-.9-2-2-2m-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59L3.62 17H19v-2H7z"/></svg>
                            </span>

                          </button>

                        <div class="px-4 mt-4 lg:px-8">
                          <nuxt-img class="" src="/assets/images/custom-payments.svg"
                            loading="lazy" format="webp" width="999" height="80"
                            sizes="sm:320px md:320px lg:320px xl:320px" alt="custom payments"/>
                        </div>

                        </div>
                    
                    </div>
                  </div>
                </div>

                <div data-testid="product-card-3"
                  class="mx-auto mt-10 max-w-lg duration-200 lg:mt-0 lg:max-w-none lg:mx-0 hover:scale-105">
                  <div class="relative z-10 py-4 bg-white rounded-lg shadow-xl">
                    <div class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                      :style="{ borderColor: primaryColor }" aria-hidden="true"></div>

                    <div class="rounded-t-lg">
                      <div>
                        <h3 class="text-4xl font-semibold text-center text-gray-900 font-ww-medium sm:-mx-6" data-testid="product-card-3-title"
                          id="tier-growth">
                          {{ products[1].title }}
                        </h3>

                        <div class="text-4xl font-semibold text-center font-ww-medium" data-testid="product-card-3-price-per-unit">
                          ${{ (products[1].price / 3).toFixed(2) }} Per unit
                        </div>

                        <div class="mt-3 w-full lg:h-10">
                        
                        </div>
                        <div class="px-2 py-1">
                          <nuxt-img class="object-contain px-2 mx-auto w-auto h-64 xl:h-80 lg:px-0" :src="products[1].imageUrl"
                            loading="lazy" format="webp" width="320" height="320"
                            sizes="sm:320px md:320px lg:320px xl:320px" :alt="products[1].title" />
                        </div>
                        <div class="flex flex-col justify-center items-center lg:mt-2">
                          <span data-testid="product-card-3-price"
                            class="flex items-start px-3 text-6xl tracking-tight text-gray-900 sm:text-6xl font-ww-medium">
                            <span class="mt-2 mr-2 text-5xl font-medium">$</span>
                            <span class="font-extrabold">{{ products[1].price }}</span>
                          </span>
                          <div class="flex gap-x-1 items-center mt-2">
                            <div>
                              <nuxt-img class="" src="/assets/images/shipping-cart.svg"
                            loading="lazy" format="webp" width="30" height="30" alt=shipping
                            sizes="sm:320px md:320px lg:320px xl:320px" />
                             
                            </div>
                            <div class="text-lg font-semibold font-ww-medium text-lifeboost-ambassador" data-testid="product-card-3-shipping-note">
                              Plus Free Shipping
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-6 py-4 -mt-1 rounded-b-lg">

                        <div class="">
                          <button @click="addToCart(products[1])" data-testid="product-card-3-button"
                            class="flex gap-x-2 justify-center items-center px-6 py-2 w-full leading-6 text-center text-white uppercase rounded-full border-2 shadow-md us-max:text-2xl text-27 sm:text-3xl lg:py-4 lg:text-2xl xl:text-4xl hover:shadow-lg hover:opacity-80 font-ww-medium hover:bg-opacity-80"
                            :style="{ backgroundColor: primaryColor, borderColor: primaryColor }"
                            aria-describedby="tier-growth">
                            {{ buttonText[1] }}
                            

                            <span class="p-2 bg-white rounded-full lg:p-2">
                              <svg class="w-6 h-6 text-lifeboost-orange-middle xl:w-8 xl:h-8" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2s2-.9 2-2s-.9-2-2-2m-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59L3.62 17H19v-2H7z"/></svg>
                            </span>

                          </button>

                        <div class="px-4 mt-4 lg:px-8">
                          <nuxt-img class="" src="/assets/images/custom-payments.svg"
                            loading="lazy" format="webp" width="999" height="80"
                            sizes="sm:320px md:320px lg:320px xl:320px" alt="custom payments"/>
                        </div>

                        </div>
                    
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
